function webpackContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackContext.resolve = webpackContext;
webpackContext.keys = function() { return []; };
module.exports = webpackContext;



/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates ^\.\/notExisting.*$
 ** module id = 6
 ** module chunks = 0
 **/